import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import axios from "axios";
import Pronounce from "./Pronounce";
import Definition from "./Definition";
import Photos from "./Photos";

export default function App(props) {
  const [keyword, setKeyword] = useState(null);
  const [data, setData] = useState(null);
  const [meanings, setMeanings] = useState(null);
  const [images, setImages] = useState(null);
  const [loaded, setLoaded] = useState(false);

  let searchForm = (
    <div className="searchForm mb-5">
      <form onSubmit={sendKeyword}>
        <input
          type="search"
          placeholder="Search for a word"
          className="searchBox px-2"
          onChange={getKeyword}
        />
        <button type="submit" className="btn-sm searchButton mx-2 px-3">
          {" "}
          Search{" "}
        </button>
      </form>
    </div>
  );

  let footer = (
    <small className="footer ms-5">
      <a href="https://github.com/JD0901/dictionary-app">Open Source</a> by
      Julie Davis
    </small>
  );

  function getKeyword(event) {
    setKeyword(event.target.value);
  }

  function sendKeyword(event) {
    event.preventDefault();
    if (keyword !== null) {
      let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
      axios.get(apiUrl).then(getData);

      let photosApiKey = `563492ad6f91700001000001d061ff860d9547ff92d02a4fb93b90e5`;
      let photosUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
      let headers = { authorization: `Bearer ${photosApiKey}` };
      axios.get(photosUrl, { headers: headers }).then(getPhotos);
    } else {
      return null;
    }
  }

  function definitionToApp(clickedTerm) {
    let synonymTerm = clickedTerm;
    sendSynonym(synonymTerm);
  }

  function sendSynonym(synonym) {
    if (synonym) {
      let word = synonym;
      let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${word}`;
      axios.get(apiUrl).then(getData);

      let photosApiKey = `563492ad6f91700001000001d061ff860d9547ff92d02a4fb93b90e5`;
      let photosUrl = `https://api.pexels.com/v1/search?query=${word}&per_page=9`;
      let headers = { authorization: `Bearer ${photosApiKey}` };
      axios.get(photosUrl, { headers: headers }).then(getPhotos);
      window.scrollTo(0, 0);
    } else {
      return null;
    }
  }

  function getData(response) {
    setData({
      word: response.data[0].word,
      phonetic: response.data[0].phonetic,
      audio: response.data[0].phonetics[0].audio,
    });
    setMeanings(response.data[0].meanings);
    setLoaded(true);
  }

  function getPhotos(response) {
    setImages(response.data.photos);
  }

  if (loaded) {
    return (
      <div className="App my-3 shadow-lg">
        <section className="searchSection shadow  pt-3 mt-5 mx-3">
          <h1 className="dictionaryApp my-3 pt-3 pb-2">Dictionary App </h1>
          {searchForm}
          <div className="Pronunciation ms-5 pb-4 d-flex">
            <Pronounce data={data} />
          </div>
        </section>
        <Definition meanings={meanings} definitionToApp={definitionToApp} />
        <Photos images={images} />
        {footer}
      </div>
    );
  } else {
    return (
      <div className="App my-3 shadow-lg">
        <section className="searchSection py-4 px-4 my-4 shadow">
          <h1 className="dictionaryApp mb-3">Dictionary App </h1>
          {searchForm}
        </section>
        {footer}
      </div>
    );
  }
}
